import { cn } from '@/lib/utils'
import { type ComponentProps, type ReactNode, useId } from 'react'
import {
    RadioGroupItem as RadioGroupItemPrimitive,
    RadioGroup as RadioGroupPrimitive,
} from './ui/radio-group'

export interface RadioGroupItemProps
    extends ComponentProps<typeof RadioGroupItemPrimitive> {
    label?: ReactNode
    /** Classe do wrapper que envolve círculo e rótulo. Só vale com `label`. */
    containerClassName?: string
}

/**
 * Botão de opção com o rótulo junto, mesmo formato do `Checkbox`.
 *
 * Sem `label` devolve só o círculo, para quando o rótulo é a linha inteira.
 */
export function RadioGroupItem({
    label,
    className,
    containerClassName,
    ...props
}: RadioGroupItemProps) {
    const idGerado = useId()
    const id = props.id ?? idGerado

    const controle = (
        <RadioGroupItemPrimitive
            {...props}
            id={id}
            className={cn('cursor-pointer', className)}
        />
    )

    if (label === undefined) return controle

    return (
        <span
            className={cn('inline-flex items-center gap-2', containerClassName)}
        >
            {controle}
            <label
                htmlFor={props.disabled ? undefined : id}
                className={cn(
                    'inline-flex items-center select-none text-foreground',
                    props.disabled
                        ? 'cursor-not-allowed opacity-50'
                        : 'cursor-pointer',
                )}
            >
                {label}
            </label>
        </span>
    )
}

export { RadioGroupPrimitive as RadioGroup }
